module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-italic.d8aade8f51e72cca8ef34d83dd2885dc.woff";